// import React from 'react';
// import {
//   Box,
//   Typography,
//   Container,
//   Link
// } from '@mui/material';
// import Footer from './Footer';
// import NavBar from './NavBar';
// import {  Card, CardContent } from '@mui/material';
// import { LocationOn, Phone, Email } from '@mui/icons-material';


// const ContactUs = () => {
//   const containerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     padding: '40px 20px',
//     backgroundColor: '#f9f9f9',
//     marginTop:'0px'
//   };

//   const formStyle = {
//     width: '100%',
//     maxWidth: '1200px',
//   };

//   const rowStyle = {
//     display: 'flex',
//     gap: '20px',
//     marginBottom: '20px',
//   };

//   const inputStyle = {
//     flex: 1,
//     padding: '18px 20px',
//     fontSize: '18px',
//     border: '1px solid #ccc',
//     borderRadius: '3px',
//     outline: 'none',
//     color: '#555',
//   };

//   const buttonStyle = {
//     padding: '16px 32px',
//     fontSize: '18px',
//     fontWeight: 'bold',
//     color: '#fff',
//     backgroundColor: '#2e6da4',
//     border: 'none',
//     borderRadius: '4px',
//     cursor: 'pointer',
//   };

//   return (
//     <div>
//         <NavBar/>
//           <Box sx={{ bgcolor: '#f5f5f5', py: 6, mt: 2 }}>
//         <Typography
//                   variant="h4"
//                   sx={{
//                     fontWeight: 'bold',
//                     backgroundColor: '#00B140',
//                     color: '#fff',
//                     marginBottom:'-50px',
//                     height: '80px',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                   }}
//                 >
//                   Contact Us
//                 </Typography>
//       </Box>
//     <div style={containerStyle}>
//       <form style={formStyle}>
//         <div style={rowStyle}>
//           <input type="text" placeholder="First Name" style={inputStyle} />
//           <input type="text" placeholder="Last Name" style={inputStyle} />
//         </div>
//         <div style={rowStyle}>
//           <input type="email" placeholder="Email ID" style={inputStyle} />
//           <input type="text" placeholder="Contact Number" style={inputStyle} />
//         </div>
//         <div style={rowStyle}>
//           <input type="text" placeholder="Enter City" style={inputStyle} />
//           <input type="text" placeholder="Enter Service" style={inputStyle} />
//         </div>
        
//            <div style={{ display: 'flex',color:'#023E62', justifyContent: 'center', marginTop: '20px' }}>
//   <button type="submit" style={buttonStyle}>SUBMIT</button>
// </div>

      
        
//       </form>
     
//     </div>

//      <Box
//       sx={{
//         display: 'flex',
//         flexWrap: 'wrap',
//         gap: 3,
//         justifyContent: 'center',
//         alignItems: 'flex-start',
//         p: 4,
//         backgroundColor: '#f9f9f9',
//       }}
//     >
//       {/* Left: Contact Card */}
//       <Card
//         elevation={2}
//         sx={{
//              minWidth: 300,
//           height: 300,
          
//           flex: 1,
        
//         }}
//       >
//         <CardContent>
//           <Box display="flex" alignItems="center" mb={1}>
//             <LocationOn color="primary" sx={{ mr: 1 }} />
//             <Typography variant="h6" fontWeight="bold">
//               PDN & ASSOCIATES
//             </Typography>
//           </Box>
//           <Typography variant="body1" gutterBottom>
//             402, PARAS PEARL, GREEN GLEN LAYOUT BELLANDUR, BANGALORE-560103
//           </Typography>

//           <Box display="flex" alignItems="center" mt={2}>
//             <Phone color="primary" sx={{ mr: 1 }} />
//             <Link href="tel:+919959502622" underline="none" color="primary">
//               +91-7760267505 , 080-42100416
//             </Link>
//           </Box>

//           <Box display="flex" alignItems="center" mt={2}>
//             <Email color="primary" sx={{ mr: 1 }} />
//             <Link href="mailto:INFO@PDNANDASSOCIATES.COM" underline="none" color="primary">
//               INFO@PDNANDASSOCIATES.COM
//             </Link>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Right: Google Map */}
//       <Box
//         sx={{
//           flex: 1,
//           minWidth: 300,
//           height: 300,
//           borderRadius: 2,
//           overflow: 'hidden',
//           boxShadow: 2,
//         }}
//       >
//         <iframe
//           title="Google Map"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.587657316173!2d78.43816241487742!3d17.43228198794946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915f3b570b27%3A0x2c0b8b8c6f6c6f6!2sBanjara%20Hills%2C%20Hyderabad%2C%20Telangana%20500034%2C%20India!5e0!3m2!1sen!2sus!4v1635789273912!5m2!1sen!2sus"
//           width="100%"
//           height="100%"
//           style={{ border: 0 }}
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//         ></iframe>
//       </Box>
//     </Box>

//     <Box sx={{ bgcolor: '#eae9e9ff', py: 8 }}>
//           <Container maxWidth="md" sx={{ textAlign: 'center' }}>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontWeight: 'bold',
//                 color: '#00B140',
//                 mb: 1,
//                 fontFamily: 'Roboto, sans-serif'
//               }}
//             >
//               GET IN TOUCH
//             </Typography>
    
//             <Link
//               href="mailto:devarajuassociates@gmail.com"
//               underline="none"
//               sx={{
//                 color: '#00B140',
//                 fontWeight: 'bold',
//                 fontSize: '1.4rem',
//                 '&:hover': {
//                   textDecoration: 'underline'
//                 }
//               }}
//             >
//               INFO@PDNANDASSOCIATES.COM
//             </Link>
//           </Container>
//         </Box>
         
    
//      <Footer/>
//      </div>
//   );
// };

// export default ContactUs;

















import React from 'react';
import {
  Box,
  Typography,
  Container,
  Link,
  Card,
  CardContent
} from '@mui/material';
import Footer from './Footer';
import NavBar from './NavBar';
import { LocationOn, Phone, Email } from '@mui/icons-material';

const ContactUs = () => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 20px',
    backgroundColor: '#f9f9f9',
    marginTop: '0px',
  };

  const formStyle = {
    width: '100%',
    maxWidth: '1200px',
  };

  const rowStyle = {
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    flexWrap: 'wrap', // ✅ allows stacking on small screens
  };

  const inputStyle = {
    flex: 1,
    minWidth: '200px',
    padding: '16px 18px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '3px',
    outline: 'none',
    color: '#555',
  };

  const buttonStyle = {
    padding: '14px 28px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#2e6da4',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavBar />

      {/* Header */}
      <Box sx={{ bgcolor: '#f5f5f5', py: 6, mt: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            backgroundColor: '#00B140',
            color: '#fff',
            marginBottom: '-50px',
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          Contact Us
        </Typography>
      </Box>

      {/* Contact Form */}
      <div style={containerStyle}>
        <form style={formStyle}>
          <div style={rowStyle}>
            <input type="text" placeholder="First Name" style={inputStyle} />
            <input type="text" placeholder="Last Name" style={inputStyle} />
          </div>
          <div style={rowStyle}>
            <input type="email" placeholder="Email ID" style={inputStyle} />
            <input type="text" placeholder="Contact Number" style={inputStyle} />
          </div>
          <div style={rowStyle}>
            <input type="text" placeholder="Enter City" style={inputStyle} />
            <input type="text" placeholder="Enter Service" style={inputStyle} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button type="submit" style={buttonStyle}>SUBMIT</button>
          </div>
        </form>
      </div>

      {/* Contact Info + Map */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: { xs: 'wrap', md: 'nowrap' }, // ✅ stack on mobile
          gap: 3,
          justifyContent: 'center',
          alignItems: 'flex-start',
          p: 4,
          backgroundColor: '#f9f9f9',
        }}
      >
        {/* Left: Contact Card */}
        <Card
          elevation={2}
          sx={{
            minWidth: 300,
            flex: 1,
            height: { xs: 'auto', md: 300 }, // ✅ auto height on mobile
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <CardContent>
            <Box display="flex" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }} mb={1}>
              <LocationOn color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6" fontWeight="bold">
                PDN & ASSOCIATES
              </Typography>
            </Box>
            <Typography variant="body1" gutterBottom>
              402, PARAS PEARL, GREEN GLEN LAYOUT BELLANDUR, BANGALORE-560103
            </Typography>

            <Box display="flex" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }} mt={2}>
              <Phone color="primary" sx={{ mr: 1 }} />
              <Link href="tel:+919606078040" underline="none" color="primary">
                +91 9606078040
              </Link>
            </Box>

            <Box display="flex" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }} mt={2}>
              <Email color="primary" sx={{ mr: 1 }} />
              <Link href="mailto:INFO@PDNANDASSOCIATES.COM" underline="none" color="primary">
                INFO@PDNANDASSOCIATES.COM
              </Link>
            </Box>
          </CardContent>
        </Card>

        {/* Right: Google Map */}
        <Box
          sx={{
            flex: 1,
            minWidth: 300,
            height: { xs: 250, md: 300 }, // ✅ smaller on mobile
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 2,
          }}
        >
          {/* <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.587657316173!2d78.43816241487742!3d17.43228198794946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915f3b570b27%3A0x2c0b8b8c6f6c6f6!2sBanjara%20Hills%2C%20Hyderabad%2C%20Telangana%20500034%2C%20India!5e0!3m2!1sen!2sus!4v1635789273912!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe> */}

          <iframe
  title="Google Map"
  src="https://www.google.com/maps?q=402+Paras+Pearl+Green+Glen+Layout+Bellandur+Bangalore+560103&output=embed"
  width="100%"
  height="100%"
  style={{
    border: "0",
    borderRadius: "8px",
    minHeight: "400px",
  }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

        </Box>
      </Box>

      {/* Footer CTA */}
      <Box sx={{ bgcolor: '#eae9e9ff', py: 8 }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#00B140',
              mb: 1,
              fontFamily: 'Roboto, sans-serif',
            }}
          >
            GET IN TOUCH
          </Typography>

          <Link
            href="mailto:devarajuassociates@gmail.com"
            underline="none"
            sx={{
              color: '#00B140',
              fontWeight: 'bold',
              fontSize: '1.4rem',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            INFO@PDNANDASSOCIATES.COM
          </Link>
        </Container>
      </Box>

      <Footer />
    </div>
  );
};

export default ContactUs;
